import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";




export const authLogin = createAsyncThunk("auth/authLogin", async (item, thunkAPI) => {
  try {
    const data = await AuthService.login(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const userLogin = createAsyncThunk("auth/userLogin", async (item, thunkAPI) => {
  try {
    const data = await AuthService.userLogin(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const register = createAsyncThunk("auth/register", async (item, thunkAPI) => {
  try {
    const data = await AuthService.register(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const verifyotp = createAsyncThunk("auth/verifyotp", async (item, thunkAPI) => {
  try {
    const data = await AuthService.verifyotp(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  try {

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return true;
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error.response?.data?.message || error.message
    );
  }
});

export const forgotPasswords = createAsyncThunk("auth/forgotPasswords", async (item, thunkAPI) => {
  try {
    const data = await AuthService.forgotPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const verifyOtpAndSetPassword = createAsyncThunk("auth/verifyOtpAndSetPassword", async (item, thunkAPI) => {
  try {
    const data = await AuthService.setPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});



export const getRoles = createAsyncThunk("auth/getRoles", async (thunkApi) => {
  try {
    const response = await AuthService.getRoles();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const getProfile = createAsyncThunk("auth/getProfile", async (thunkApi) => {
  try {
    const response = await AuthService.FetchProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const getuserProfile = createAsyncThunk("auth/getuserProfile", async (thunkApi) => {
  try {
    const response = await AuthService.getProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const editProfile = createAsyncThunk(
  "auth/editProfile",
  async (item, thunkApi) => {
    try {
      const response = await AuthService.editProfile(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const changePassword = createAsyncThunk("auth/changePassword", async (item, thunkApi) => {
  try {
    const response = await AuthService.changePassword(item);
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


const initialState = {
  loading: false,
  error: "",
  authdata: [],
  user: AuthService.getUserDetails() || null,
  profile: null, // ✅ ADD THIS
};


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // **Handle Login**
      .addCase(authLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.user = null;
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(authLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Register**
      .addCase(register.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(register.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(register.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(editProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(editProfile.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(editProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(verifyotp.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(verifyotp.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.user = action.payload?.data || action.payload;
      })
      .addCase(verifyotp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Org Login**
      .addCase(userLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getuserProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getuserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload?.data; // ✅ CLEAN
      })
      .addCase(getuserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
        state.user = null;
        state.profile = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(getRoles.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(getRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export default authSlice.reducer;
